import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { ObservablesService } from "../Services/observables/observables";
import { tap } from "rxjs/operators";

@Injectable()
export class SessionTimeOutInterceptor implements HttpInterceptor {
  constructor(private observablesService: ObservablesService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((response: HttpEvent<Response>) => {
        if (response instanceof HttpResponse) {
          if (
            response.body.data &&
            response.body.data.data &&
            response.body.data.globalAttributes &&
            response.body.data.globalAttributes.type &&
            response.body.data.globalAttributes.type === "kick-out"
          ) {
            this.observablesService.sessionStop.next();
          }

          if (response.headers.get("X-Bolt-StopPing")) {
            this.observablesService.sessionStop.next();
          }
        }
      })
    );
  }
}
